export function filterNameToUrlParameter(filter_name, multiple_values_allowed) {
    let url_param = "f_" + filter_name;

    if (true !== multiple_values_allowed) {
        return url_param;
    }

    return url_param + "[]";
}

export function urlParameterToFilterName(url_parameter) {
    let filter_name = url_parameter.substr(2); // remove "f_"

    if (filter_name.indexOf("[]") === -1) {
        return filter_name;
    }

    return filter_name.substring(0, filter_name.indexOf("[]"));
}
